import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectCredentials } from 'features/auth/authSlice';

export const useAuth = () => {
	const credentials = useSelector(selectCredentials);

	return useMemo(() => credentials, [credentials]);
};
